import moment from 'moment';
import { DATE_LONG_FORMAT_WITH_YEAR } from '../../../data/constants/datetime';
import { eventMomentFactory } from '../../../data/misc/eventMomentFactory';
import { useEvent } from '../../../data/hooks/eventHooks';

function TimeFromNow(props) {
    const { children } = props,
        event = useEvent(),
        timestamp = eventMomentFactory(event, children ?? '');

    if (!children) return null;

    // if more than one year away, just show the date
    if (moment().diff(timestamp, 'years', true) > 1) {
        return timestamp.format(DATE_LONG_FORMAT_WITH_YEAR);
    }

    return timestamp.fromNow();
}

export default TimeFromNow;
